import React, { useEffect, useState } from 'react';
import { IoIosInformationCircle } from 'react-icons/io';
import { TiArrowUpOutline } from "react-icons/ti";


const NotificationPopUp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300 && !isDismissed) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const handleClose = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };

  const handleConversionClick = (e) => {
    e.preventDefault();
    setIsVisible(false);
    setIsDismissed(true);
    document.getElementById('askproposal')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className={`slide-in-unique ${isVisible ? 'active-unique' : ''} ${isDismissed ? 'hidden' : ''}`}
    >
      <span className="close-btn-unique" onClick={handleClose}>&times;</span>
      <h2 className="flex items-center text-lg lg:text-2xl font-bold">
        <IoIosInformationCircle className="mr-2 text-black" />
        Sabia que:
      </h2>
      <p>
        Todos os nossos planos proporcionam o <b>acesso imediato, exclusivo</b> e sem qualquer custo, a <b>cuidados primários</b> a partir de sua casa, <b>24 horas por dia, 7 dias</b>.
      </p>
      <button
        onClick={handleConversionClick}
        className="conversion-btnbasic flex items-center justify-center"
        style={{ color: "#ffffff", marginTop: "10px" }}
      >
        <TiArrowUpOutline className="mr-2" />
        Fazer já simulação.
      </button>
    </div>
  );
};

export default NotificationPopUp;
